export default __webpack_public_path__ + "static/media/sharingimage.0c4111ee.png";